import * as React from "react";

const FacebookIcon: React.FC = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M39.0162 19.6274C38.993 15.9046 37.905 12.2661 35.8807 9.14163C33.8564 6.01715 30.9804 3.53715 27.5921 1.99445C24.2039 0.451747 20.445 -0.0892254 16.7592 0.435406C13.0734 0.960038 9.61475 2.52836 6.79153 4.9552C3.96831 7.38204 1.89846 10.566 0.826373 14.1313C-0.245709 17.6965 -0.275252 21.494 0.741233 25.0755C1.75772 28.6569 3.77778 31.8728 6.5629 34.3432C9.34803 36.8137 12.7819 38.4356 16.4591 39.0176V25.306H11.5039V19.6319H16.4602V15.3033C16.4602 10.3849 19.3708 7.66827 23.8287 7.66827C25.292 7.68885 26.7519 7.81702 28.1964 8.05175V12.8798H25.7339C25.3133 12.8253 24.8858 12.8661 24.4831 12.9992C24.0805 13.1323 23.7129 13.3543 23.4076 13.6486C23.1023 13.943 22.8671 14.3023 22.7195 14.6998C22.5718 15.0974 22.5154 15.5231 22.5546 15.9454V19.6241H27.9656L27.1006 25.2982H22.559V39.0098C27.1585 38.2629 31.3414 35.9016 34.3574 32.3496C37.3733 28.7976 39.0251 24.2871 39.0162 19.6274Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(FacebookIcon);
